import { Header } from "../components/Header";
import styled from 'styled-components'
import { theme } from "../theme";
import { Search, PersonPinRounded, CheckCircle, Photo, AdminPanelSettings, Download } from '@mui/icons-material';
import { Text } from "../components/Text";
import { Box } from "../components/Box";
import { TextInput } from "../components/TextInput";
import { useState } from "react";
import { authenticator } from "../services/Authenticator";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/Button";

const LoginContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-grow: 1;
  flex-direction: column;
`

const LoginButton = styled.div`
  padding: ${theme.spacing.sm};
  background-color: ${theme.palette.primary};
  font-weight: ${theme.typography.weights.extra};
  font-size: ${theme.typography.textSizes.sm};
  color: white;
  border-radius: 10px;
  text-align: center;
  width: 300px;
  cursor: pointer;
  box-sizing: border-box;
`

export function Login() {

  const navigate = useNavigate()

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  async function login() {
    try {
      await authenticator.login(username, password)
      navigate('/')
    } catch(error) {
      console.error(error)
      alert("Failed to login");
    }
  }

  return (
    <>
      <Header />

      <LoginContainer>
          
        <TextInput 
          autofocus 
          value={username} 
          onChange={(newValue) => setUsername(newValue)} 
          placeholder="Email Address" 
        />
        
        <TextInput 
          value={password} 
          onChange={(newValue) => setPassword(newValue)} 
          placeholder="Password" 
          type='password'
        />
        
        <Button 
          label='Login'
          onClick={login}
        />
        
      </LoginContainer>
    </>
  )
}